import { render, staticRenderFns } from "./TableRowData.vue?vue&type=template&id=18131a79&"
import script from "./TableRowData.vue?vue&type=script&lang=js&"
export * from "./TableRowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports